/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsEmailListItem
 */
export interface MelcoModelsEmailListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmailListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmailListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmailListItem
     */
    email_address?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsEmailListItem
     */
    time_stamp?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsEmailListItem
     */
    is_email_sent?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsEmailListItem
     */
    total?: number;
}

export function MelcoModelsEmailListItemFromJSON(json: any): MelcoModelsEmailListItem {
    return MelcoModelsEmailListItemFromJSONTyped(json, false);
}

export function MelcoModelsEmailListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsEmailListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'time_stamp': !exists(json, 'time_stamp') ? undefined : (new Date(json['time_stamp'])),
        'is_email_sent': !exists(json, 'is_email_sent') ? undefined : json['is_email_sent'],
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function MelcoModelsEmailListItemToJSON(value?: MelcoModelsEmailListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'product_code': value.product_code,
        'email_address': value.email_address,
        'time_stamp': value.time_stamp === undefined ? undefined : (value.time_stamp.toISOString()),
        'is_email_sent': value.is_email_sent,
        'total': value.total,
    };
}


